<template>
	<div>
		<a-modal v-show='ishand' id='touzhe' width='70rem' v-model="visible" on-ok="handleOk1"
			v-dragModal class='myfus'
			@cancel="handleCancel(0)" :footer="null" :keyboard='false' :maskClosable='false'>
			<!-- <div class='mark'>
				<div :style="{backgroundColor: findstatic==1? '#e79b08':''}" @click='handfind(1)'>投資組合</div>
				<div :style="{backgroundColor: findstatic==2? '#e79b08':''}" @click='handfind(2)'>待成交訂單</div>
				<div :style="{backgroundColor: findstatic==3? '#e79b08':''}" @click='handfind(3)'>日常訂單</div>
				<div :style="{backgroundColor: findstatic==4? '#e79b08':''}" @click='handfind(4)'>日常成交</div>
			</div> -->
			<div class='mark-lisp'>
				<div style="background-color: #0c8b97;border-radius:  10px 10px 0 0;color: #fff;width: 100%;">投資組合</div>

			</div>
			<div solt='title' style="position: relative;">
				<!-- <div style="position: absolute;top: 0;left: 0;background-color: red;">標題</div> -->
			</div>
			<div style="padding-top: 2.8rem;">
				<div v-if='findstatic == 1'>
					<a-row>
						<a-col :span='7'>
							<a-table style="width:95%;" :columns="columns" :data-source="columnsDatas" id='fromtable'
								:rowKey='(record, index) => index' :pagination="false">
								<span slot='alltext' style="font-size: 0.85rem;" :class='england?"ckedf":"ckedfx"'>
									<div>
										<div  @click='hkdstatic = true'>
											{{hkditem + '等值'}}
											<a-icon type="caret-down" />
										</div>
										<div v-for='(val,ind) in arr2' @click='fans(1,val)' class='warp-abv' v-if='hkdstatic'
										:class='ind == 1?"centerdiv":""'>
											{{val.ccy}}
										</div>
									</div>
								</span>
								<span slot='stockname1' style="font-size: 0.85rem;" :class='!england?"ckedf1":"ckedfs"'
									@click='fans(0)'>現金餘額</span>
								<div slot='b' slot-scope='record'>
									
									<div style="text-align: left;" v-if='columnsDatas == arr2'
										:style='{color:record.amt == 0?"":record.amt > 0?"#00ab3b":"#f13d3c "}'>{{fanjiebao(record.amt,2)}}
									</div>
									<div style="text-align: left;" v-else
										:style='{color:record.b == 0?"":record.b > 0?"#00ab3b":"#f13d3c"}'>{{fanjiebao(record.b,2,hkdnum)}}
									</div>
								</div>
								<div slot='a' slot-scope='record'>
									<div style="text-align: left;">{{record.a}} {{record.ccy}}</div>
								</div>
								
								<!-- 	<div slot='hot_status' slot-scope="record" style="white-space: nowrap;" :title='record.stockname'>
									<div v-if='record.hot_status == 1' style='display: inline-block;margin-right: 5px;'><img :src="icon_fasong" alt="" style='width: 1rem;'></div>
									<div v-if='record.hot_status == 2' style='display: inline-block;margin-right: 5px;'><img :src="icon_hot" alt="" style='width: 1rem;'></div>
									<div style='display: inline-block;'>
										{{record.stockname}}
									</div>
								</div> -->
							</a-table>
						</a-col>
						<a-col :span='17'>
							<a-table style="width:100%;overflow: auto;height: 20rem;"
							 :columns="column" :data-source="columnsData" id='fromtable1'
							 :rowKey='(record, index) => index' :pagination="false">
								<div slot='price' slot-scope='record' style="position: relative;">
									<a-input v-model="record.price" @blue='fanssss' style='width: 100%;'>
										<a-tooltip slot="suffix" title="點擊保存">
										        <!-- <a-icon type="file-add" style="color:gray" @click='handit(record)'/> -->
												<img :src="require('@/image/simu/save.png')" 
												style="cursor: pointer;width: .7rem;" title='點擊保存'
												alt="點擊保存" @click='handit(record)'>
										</a-tooltip>
									</a-input>
									<!-- <div style="position: absolute;top: .3rem;left: .2rem;color: rgba(0, 0, 0, 0.65);">$</div> -->
								</div>
								<div slot='mv' slot-scope='record'>
									{{record.mv}}
								</div>
								<div slot='plx' slot-scope='record' style="position: relative;">
												<img :src="require('@/image/simu/listbtn.png')" title='點擊打開折線圖'
												style="cursor: pointer;width: .9rem;"
												alt="點擊打開折線圖" @click='listbtn(record)'>
								</div>
							</a-table>
						</a-col>
					</a-row>
				</div>
				<div v-else id='min-list'>
					<a-table style="width:100%;" :columns="columore" :data-source="moreDatas" id='fromtable2'
						:rowKey='(record, index) => index' :pagination="false">
					</a-table>
				</div>
			</div>
		</a-modal>
	</div>
</template>

<script>
	import App from '@/assets/app.js';
	export default {
		props: ['openstatic'],
		data() {
			return {
				hkdnum:'1',//显汇率
				hkditem:'HKD',//
				hkdstatic:false,
				findstatic: 1,
				england: true,
				visible: true,
				ishand: true,
				form: {
					a3: '',
					a2: '',
					a1: '1',
				},
				col4: [
					{
					title: '買/沽',
					dataIndex: 'p',
					sorter: true,
					align: 'center',
					width: '13%',
				}, {
					title: '市場',
					sorter: true,
					dataIndex: 'f',
					align: 'center',
					width: '13%',
				}, {
					title: '產品名稱',
					sorter: true,
					dataIndex: 'a',
					align: 'center',
					width: '13%',
				}, {
					title: '股票名稱',
					sorter: true,
					dataIndex: 'product_name',
					align: 'center',
					width: '13%',
				}, {
					title: '成交平均價',
					sorter: true,
					dataIndex: 'c',
					align: 'center',
					width: '13%',
				}, {
					title: '數量',
					sorter: true,
					dataIndex: 'qty',
					align: 'center',
					width: '13%',
				}, {
					title: '金額',
					sorter: true,
					dataIndex: 'e',
					align: 'center',
					width: 'auto',
				}],
				col1: [
					{
					title: '更改/取消',
					dataIndex: 'a',
					align: 'center',
					width: '8%',
				}, {
					title: '狀態',
					dataIndex: 'b',
					sorter: true,
					align: 'center',
					width: '6%',
				}, {
					title: '更改/取消',
					dataIndex: 'c',
					sorter: true,
					align: 'center',
					width: '9%',
				}, {
					title: '訂單編號',
					dataIndex: 'd',
					sorter: true,
					align: 'center',
					width: '7%',
				}, {
					title: '買/沽',
					dataIndex: 'e',
					sorter: true,
					align: 'center',
					width: '6%',
				}, {
					title: '市場',
					sorter: true,
					dataIndex: 'f',
					align: 'center',
					width: '6%',
				}, {
					title: '商品',
					dataIndex: 'g',
					sorter: true,
					align: 'center',
					width: '6%',
				}, {
					title: '類別',
					dataIndex: 'h',
					sorter: true,
					align: 'center',
					width: '6%',
				}, {
					title: '貨幣',
					dataIndex: 'i',
					sorter: true,
					align: 'center',
					width: '6%',
				}, {
					title: '價格',
					dataIndex: 'j',
					sorter: true,
					align: 'center',
					width: '6%',
				}, {
					title: '數量',
					dataIndex: 'k',
					sorter: true,
					align: 'center',
					width: '6%',
				}, {
					title: '價格',
					dataIndex: 'l',
					sorter: true,
					align: 'center',
					width: '6%',
				}, {
					title: '待成交訂單',
					dataIndex: 'm',
					sorter: true,
					align: 'center',
					width: '9%',
				}, {
					title: '已成交',
					dataIndex: 'q',
					sorter: true,
					align: 'center',
					width: '7%',
				}, {
					title: '最後更新',
					sorter: true,
					dataIndex: 'r',
					align: 'center',
					width: 'auto',
				}
				],
				mor1: [],
				columore: [],
				moreDatas: [],
				columns: [{
						// title: '',
						// dataIndex: 'a',
						align: 'center',
						width: '60%',
						slots: {
							title: 'alltext'
						},
						scopedSlots: {
							customRender: 'a'
						}
					},
					{
						// title: '股票名稱',
						dataIndex: '',
						align: 'center', //center
						width: 'auto',
						// ellipsis: true,
						slots: {
							title: 'stockname1'
						},
						scopedSlots: {
							customRender: 'b'
						},
					},
				],
				column: [
					{
					title: '股票編碼',
					dataIndex: 'product_code',
					align: 'center',
					width: '11%',
				}, {
					title: '股票名稱',
					dataIndex: 'product_name',
					align: 'center',
					width: '11%',
				}, {
					title: '總股數',
					dataIndex: 'qty',
					align: 'center',
					width: '11%',
				}, {
					title: '平均價',
					dataIndex: 'avgprice',
					align: 'center',
					width: 'auto',
				}, {
					title: '參考價',
					dataIndex: '',
					align: 'center',
					width: '15%',
					scopedSlots: {
						customRender: 'price'
					}
				}, {
					title: '市值（參考價）',
					dataIndex: '',
					align: 'center',
					width: '17%',
					scopedSlots: {
						customRender: 'mv'
					}
				}, {
					title: '盈利（虧損）',
					dataIndex: 'pl',
					align: 'center',
					width: '15%',
					},{
						title: '走勢圖',
						dataIndex: '',
						align: 'center',
						width: '9%',scopedSlots: {
						customRender: 'plx'
					}
						}
				 ],
				arr1: [{
					a: '可用現金',
					b: '0',//价钱
					c:'total_cash',
				}, {
					a: '交易限制',
					b: '0',
					c:'',
				}, {
					a: '已用金額',
					b: '0',
					c:'',
				}, {
					a: '可動用現金',
					b: '0',
					c:'avail_pp',
				}, {
					a: '總貨值(前收市價)',
					b: '0',
					c:'total_mkt_value',
				}, {
					a: '投資組合總值(前收市價)',
					b: '0',
					c:'ref_portfolio',
				}],
				arr2: [{
					a: 'KKK',
					b: '0'
				}, {
					a: 'HKI',
					b: '0'
				}, {
					a: '已用金額',
					b: '0'
				}, {
					ccy : '可動用現金',
					amt: '0'
				}, ],
				columnsDatas: [],
				columnsData: [],
			}
		},
		mounted() {
			this.columnsDatas = this.arr1
			// this.postdata()
			this.portfoliofn()
			// this.columore = this.column
		},
		watch:{
			moreDatas:{
				
			}
		},
		methods: {
			listbtn(record){
				this.$emit('child', '71-1',record)
			},
			handit(val){
				let num  = val.price.split(',').join('')
				this.$ajax({
					url:this.$api.newreferenceval,
					method:'post',
					data:{
						"token":this.$store.state.token,
						 "product_code":val.stockcode,
						 "referenceval":num
					}
				}).then(res=>{
					if(res.data.qmiscode === 1000){
						this.portfoliofn()
					} else {
						 App.oTool.warningT(res.data.qmismsg);
					}
				})
			},
			fanssss(){
				
			},
			fanjiebao(val,to=2,num=1){
				//金额转换 分->元 保留2位小数 并每隔3位用逗号分开 1,234.56
				      var str = (val/num).toFixed(to) + '';
				      var intSum = str.substring(0,str.indexOf(".")).replace( /\B(?=(?:\d{3})+$)/g, ',' );//取到整数部分
				      var dot = str.substring(str.length,str.indexOf("."))//取到小数部分搜索
				      var ret = intSum + dot;
				      return ret;
				    //输出结果->20,000.00
			},
			uuid() {
				var s = [];
				var hexDigits = "0123456789abcdef";
				for (var i = 0; i < 36; i++) {
					s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
				}
				s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
				s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
				s[8] = s[13] = s[18] = s[23] = "-";
				var uuid = s.join("");
				return uuid;
			},
			postdata() {
				let obj = {
					client_acc_code: '1000005',
					localized_name: 'Y',
					// price:'',
					// exchange_code:"",
					// product_code:'',
				}
				// for(let key in obj){
				// 	obj[key] = this.form[key]
				// }
				let uuid = this.uuid()
				this.$ajax({
					method: 'post',
					url: this.$api.adminurls,
					contentType: '',
					data: {
						command: this.$axoisfix('portfolio', obj, uuid),
						language: 'big5',
						msgnum: uuid,
						token: "daca4cca-f334-4c26-8165-3f8d583e17fe",
						username: 1000005,
					}
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						// App.oTool.successT();
						// 左側 rate 汇l
						
						// this.arr1.map(ev=>{
						// 	if(ev.c){
						// 		ev.b = res.data.message[ev.c]
						// 	}
						// })
						
						// if (res.data.message.cash_pos) {
						// 	if (res.data.message.cash_pos.cash.constructor === Array) {
						// 		this.arr2 = res.data.message.cash_pos.cash
						// 	} else if (res.data.message.cash_pos.cash.constructor === Object) {
						// 		this.arr2 = [res.data.message.cash_pos.cash]
						// 	}
						// }
						// //获取hkd的汇率
						// this.arr2.map(ev=>{
						// 	if(ev.ccy == 'HKD'){
						// 		this.hkdnum = ev.rate
						// 	}
						// })
						this.portfoliofn()
						//右側列表
						// if (res.data.message.product_pos) {
						// 	if (res.data.message.product_pos.product.constructor === Array) {
						// 		this.columnsData = res.data.message.product_pos.product
						// 	} else if (res.data.message.product_pos.product.constructor === Object) {
						// 		this.columnsData = [res.data.message.product_pos.product]
						// 	}
						// }
						// this.columnsData.map(ev=>{
						// 	ev.qty = this.fanjiebao(ev.qty,2).split('.')[0]
						// 	ev.price ='$' + this.fanjiebao(ev.price,3)
						// 	ev.mv = this.fanjiebao(ev.mv,3)>0?this.fanjiebao(ev.mv,3):0
						// 	ev.pl = this.fanjiebao(ev.pl,2)
						// })
					} else {
						// App.oTool.warningT(res.data.qmismsg);
					}
					
				})
			},
			portfoliofn(){
				this.$ajax({
					method: 'post',
					url: this.$api.portfolio,
					data: {
						token: this.$store.state.token
					}
				}).then(res => {
					if(res.data.qmiscode == 1000){
						//取价钱
						this.arr1.map(ev=>{
							if(ev.c){
								ev.b = res.data[ev.c]
							}
						})
						
						this.arr2 = res.data.cash_pos
						//获取hkd的汇率
						this.arr2.map(ev=>{
							if(ev.ccy == 'HKD'){
								this.hkdnum = ev.rate
							}
						})
						
						//右侧列表
						this.arr1[0]['b'] = res.data.amt
						this.columnsData = res.data.product_pos
						this.columnsData.map(ev=>{
							ev.qty = this.fanjiebao(ev.qty,2).split('.')[0]
							ev.price = this.fanjiebao(ev.price,3)
							ev.mv = ev.mv?this.fanjiebao(ev.mv,3):0
							ev.pl = this.fanjiebao(ev.pl,2)
							ev.avgprice = this.fanjiebao(ev.avgprice,2)
						})
						}
					else{
						this.$message.error(res.data.qmismsg)
					}
					})	
			},
			handleCancel(ev) {
				this.$emit('child', 0)
			},
			handleOk1() {

			},
			fans(val,item) {
				if(val){
					this.hkditem = item.ccy
					this.hkdnum = item.rate
				}
				this.england = val
				this.columnsDatas = []
				this.columnsDatas = this.england ? this.arr1 : this.arr2
				this.hkdstatic = false
			},
			handfind(val) {
				this.findstatic = val
				if (this.findstatic == 3 || this.findstatic == 2) {
					this.columore = this.col1
					// this.moreDatas= this.mor1
				} else if (this.findstatic == 4) {
					this.columore = this.col4
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.mark-lisp {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;

		div {
			text-align: center;
			width: 6rem;
			font-size: 1rem;
			padding: .5rem 1rem;
			display: inline-block;
		}
	}

	.ckedf {
		background-color: #0c8b97;
		position: absolute;
		top: 1px;
		left: 0;
		color: #fff;
		width: 11.1rem;
		height: 52.8px;
		line-height: 52.8px;
	}
	.ckedfx {
		background-color: #fff;
		position: absolute;
		top: 1px;
		left: 2px;
		width: 11.1rem;
		height: 52.8px;
		line-height: 52.8px;
	}

	.ckedf1 {
		background-color: #0c8b97;
		position: absolute;
		top: 1px;
		right: 0;
		color: #fff;
		width: 7.5rem;
		height: 52.8px;
		line-height: 52.8px;
	}
	.ckedfs {
		background-color: #fff;
		position: absolute;
		top: 1px;
		right: 2px;
		width: 7.5rem;
		height: 52.8px;//2.79rem
		line-height: 52.8px;
	}

	.mark {
		margin-top: 1rem;
		background-color: #0c8b97;

		div {
			width: 7rem;
			font-size: 1rem;
			padding: .5rem 1rem;
			display: inline-block;
			text-align: center;
			color: #fff;
		}
	}
</style>
<style lang="scss">
	.warp-abv{
		    background: #fff;
		    border: 1px solid #d8d8d8;
			height: 2rem;
			line-height: 2rem;
			cursor: pointer;
			color: #000 !important;
	}
	.centerdiv{
		border-top: 0;
		border-bottom:0 ;
	}
	.warp-abv:hover{
		background-color: #5cb1b9;
	}
	#touzhe {
		.ant-modal-header,
		.ant-modal-body {
			background-color: #fff !important;
		}
		.ant-modal {
			top: 12vh;
		}
		.ant-table-body, .ant-table-content{
			border-left: .5px solid #e8e8e8;
			border-right: .5px solid #e8e8e8;
			border-top: .5px solid #e8e8e8;
		}
		.ant-table-placeholder{
			border-right: .5px solid #e8e8e8;
		}
		.ant-modal-close-x {
			.anticon svg {
				color: #5cb1b9;
				position: relative;
				top: .8rem
			}
		}

		.ant-table-column-title {
			font-weight: 600;
		}

		.ant-table-row-cell-break-word {
			color: #000;
		}

		#min-list {

			.ant-table-thead>tr>th,
			.ant-table-tbody>tr>td {
				padding: 16px 0;
			}
		}

		.ant-table-header-column {
			.ant-table-column-title {
				font-size: 0.85rem;
			}
		}

		.ant-modal-content {
			border-radius: 10px !important;
		}

		.ant-form-item {
			margin-bottom: 1rem;
		}

		.ant-form-item label {
			font-size: 1rem !important;
		}

		.ant-select-selection-selected-value {
			font-size: 1rem !important;
		}

		.ant-form-item-children {
			font-size: 1rem !important;
		}

	}
</style>
